/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation FallbackRouteCreateMutation($customerAccountId: ID!, $type: CUSTOMER_TYPE!, $displayName: String!) {
  FallbackRouteCreate(customerAccountId: $customerAccountId, type: $type, displayName: $displayName) {
    message
    status
  }
}
`
